import { render, staticRenderFns } from "./CommunityCard.vue?vue&type=template&id=20fe3453&scoped=true&"
import script from "./CommunityCard.vue?vue&type=script&lang=js&"
export * from "./CommunityCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCard.vue?vue&type=style&index=0&id=20fe3453&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe3453",
  null
  
)

export default component.exports